import { SystemField } from "./system-field";

export class GlAccMapping extends SystemField{ 
     object_name?:string;
     obj_record_id?:string;
     chart_of_acc_id?:string;
     acc_type?:string;
     note?:string;
     code?:string;
     is_active?:number;
}
